<div class="row">
  <div
    *ngFor="let package of dashBoardPackages; let i = index"
    class="col-lg-3 col-md-6"
  >
    <div
      [className]="
        showDetailClicked && currentSelectedPackageId == package.ID
          ? 'card-1 cursor-pointer  Shadow top_arrow dashboardPackageBox'
          : 'card-1 cursor-pointer  dashboardPackageBox'
      "
      (click)="homeComponent.toggleServiceDetails(package.ID.toString())"
    >
      <div class="row border-bottom">
        <div class="col-sm-12">
          <div
            class="card-title"
            ngbTooltip="{{ isEnglish ? package.NameEN : package.NameAR }}"
          >
            <strong>
              {{ isEnglish ? package.NameEN : package.NameAR }}
            </strong>
          </div>
          <div
            *ngIf="package.AboutToExpireLicensesCount > 0"
            class="license-expiry text-right setting bold"
          >
            {{ package.AboutToExpireLicensesCount }}
            <img
              [ngbTooltip]="
                package.AboutToExpireLicensesCount > 1
                  ? ('trMoreThanOneLicensesAreAboutToExpire' | translate)
                  : ('trOneLicenseIsAboutToExpire' | translate)
              "
              container="body"
              tooltipClass="tooltip-bg-reddish"
              src="assets/Images/Icons/danger-sign.png"
            />
          </div>
        </div>
      </div>

      <div class="row pt-1">
        <div class="col-10">
          <div class="row">
            <div class="col-10 direction_rtl alignment_right">
              <ng-container *ngIf="package.ID != 5">
                <h6 class="text-primary">{{ 'ActiveLicenses' | translate }}</h6>
              </ng-container>

              <ng-container *ngIf="package.ID == 5">
                <h6 class="text-primary">{{ 'Material' | translate }}</h6>
              </ng-container>
            </div>
            <div class="col-2 direction_rtl alignment_right">
              <label class="font-weight-bold">{{
                package.ActiveLicensesCount
              }}</label>
            </div>
            <div class="col-10 direction_rtl alignment_right">
              <ng-container *ngIf="package.ID != 5">
                <h6 class="text-primary">
                  {{ 'ExpiredLicenses' | translate }}
                </h6>
              </ng-container>

              <ng-container *ngIf="package.ID == 5">
                <h6 class="text-primary">{{ 'Cites' | translate }}</h6>
              </ng-container>
            </div>
            <div class="col-2 direction_rtl alignment_right">
              <label class="color-2 font-weight-bold">{{
                package.ExpiredLicensesCount
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="dashBoardPackages.length > 0 && currentSelectedPackage">
  <app-registered-approved-materials
    *ngIf="
      currentSelectedPackageId == PackageTypeEnum.RegisteredApprovedMaterials
    "
    [packageObject]="currentSelectedPackage"
  >
  </app-registered-approved-materials>
  <app-material-balances-cities
    *ngIf="currentSelectedPackageId == PackageTypeEnum.MaterialBalancesCities"
    [packageObject]="currentSelectedPackage"
  >
  </app-material-balances-cities>
  <app-licenses-for-practicing-activities
    *ngIf="
      currentSelectedPackageId ==
      PackageTypeEnum.LicensesForPracticingActivities
    "
    [packageObject]="currentSelectedPackage"
  >
  </app-licenses-for-practicing-activities>
  <app-licenses-for-practicing-professional
    *ngIf="
      currentSelectedPackageId ==
      PackageTypeEnum.LicensesForPracticingProfessional
    "
    [packageObject]="currentSelectedPackage"
  >
  </app-licenses-for-practicing-professional>
</ng-container>
